import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Main view components
import { ClientComponent } from './client/client.component';

// Error Components
import { AccessDeniedComponent } from './error/access-denied/access-denied.component';
import { PageNotFoundComponent } from './error/page-not-found/page-not-found.component';
import { ServiceErrorComponent } from './error/service-error/service-error.component';

// Shared Services
import { PreviousUrlService } from './shared/PreviousUrl.Service';
import { GlobalHeaderComponent } from './global-header/global-header.component';
import { GlobalFooterComponent } from './global-footer/global-footer.component';
import { AppInsightsService } from './shared/AppInsights.Service';
import { ErrorHandlerService } from './shared/ErrorHandler.Service';

// pipes
import { EmailMaskPipe } from './pipe/email-mask.pipe';
import { PhoneMaskPipe } from './pipe/phone-mask.pipe';
import { SSNMaskPipe } from './pipe/ssn-mask.pipe';
import { HostRedirectPipe } from './pipe/host-redirect.pipe';
import { ClientInitService } from './shared/ClientInitService';

const routes: Routes = [

  { path: '', component: ClientComponent },
  { path: 'ces', component: ClientComponent },
  { path: 'error', component: ServiceErrorComponent },
  { path: 'ces/error', component: ServiceErrorComponent },
  { path: '404', component: PageNotFoundComponent},
  { path: 'ces/404', component: PageNotFoundComponent},
  { path: '401', component: AccessDeniedComponent},
  { path: 'ces/401', component: AccessDeniedComponent},
  { path: '**', redirectTo: '/404'}
];

@NgModule({
  declarations: [
    AppComponent,
    AccessDeniedComponent,
    PageNotFoundComponent,
    ServiceErrorComponent,
    GlobalHeaderComponent,
    GlobalFooterComponent,
    EmailMaskPipe,
    PhoneMaskPipe,
    SSNMaskPipe,
    HostRedirectPipe,
    ClientComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule.forRoot(routes,{ scrollPositionRestoration: 'enabled' }),
    NgbModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  exports:[HostRedirectPipe],
  providers: [ClientInitService, PreviousUrlService, {provide: APP_BASE_HREF, useValue : '/client/' }, {provide: ErrorHandler, useClass: ErrorHandlerService}, AppInsightsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
